__turbopack_context__.v({
  "callout": "xMoJpW_callout",
  "ol": "xMoJpW_ol",
  "section": "xMoJpW_section",
  "table": "xMoJpW_table",
  "ul": "xMoJpW_ul",
});
